import React from 'react';
import DashboardSidebar from './DashboardSidebar';
import { useSidebar } from '../contexts/SidebarContext';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export default function DashboardLayout({ children }: DashboardLayoutProps) {
  const { isOpen, setIsOpen, isCollapsed, setIsCollapsed } = useSidebar();

  return (
    <div className="min-h-screen bg-black">
      <DashboardSidebar 
        isOpen={isOpen} 
        setIsOpen={setIsOpen}
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
      />
      
      {/* Main content with margin for sidebar */}
      <div className={`transition-all duration-300 ${isCollapsed ? 'md:ml-16' : 'md:ml-64'}`}>
        {/* Mobile header */}
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3 flex items-center justify-between">
          <button
            onClick={() => setIsOpen(true)}
            className="text-gray-400 hover:text-white"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <h1 className="text-lg font-semibold text-white">Dashboard</h1>
          <div className="w-6"></div>
        </div>

        {/* Main content */}
        {children}
      </div>
    </div>
  );
}